
<div class="row" *ngIf="!portfolioModel?.profileData?.is529">
  <!-- Commodity fund (0517) should show Fixed Income characteristics instead of Equity.
  So added logic to hide equity using Fund Id -->
  <div *ngIf="!portfolioModel?.profileData?.is529 && portfolioModel?.profileData?.fundId !== '0517' &&
  (((portfolioModel?.profileData?.isStock && !portfolioModel?.profileData?.isConvertibleFund &&
  !(portfolioModel?.profileData?.isFundOfFunds && !portfolioModel?.profileData?.isHybridFund)))
  && ((portfolioModel?.profileData?.isMarketNeutralFund &&
  (portfolioModel?.characteristic?.equityCharacteristic?.fund ||
  portfolioModel?.characteristic?.equityCharacteristic?.benchmark)) ||
  (!portfolioModel?.profileData?.isMarketNeutralFund &&
  (portfolioModel?.characteristic?.equityCharacteristic?.fund ||
  portfolioModel?.characteristic?.equityCharacteristic?.benchmark))))">
          <p class="date rps-paragraph-two rps-grey" *ngIf="portfolioModel?.characteristic?.equityCharacteristic?.asOfDate"
          data-rpa-tag-id="characteristicsDate">as of {{
            portfolioModel?.characteristic.equityCharacteristic.asOfDate | ESTPipe }}
          </p>
     <div class = "char-table">
      <equity-characteristic [fundId]='portfolioModel?.profileData?.ticker' [portfolioModel]='portfolioModel'
      [benchmarkFootNote]='benchmarkFootNote' [portfolioFootNote]='portfolioFootNote'>
      </equity-characteristic>
    </div>
  </div>
  <div *ngIf="portfolioModel?.profileData?.isBalanced &&
             ((!portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isFundOfFunds && !portfolioModel?.profileData?.isHybridFund) ||
             (portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isHybridFund ))">
        <p class="date rps-paragraph-two rps-grey" *ngIf="portfolioModel?.characteristic?.equityCharacteristic?.asOfDate"
        data-rpa-tag-id="characteristicsDate">as of {{
            portfolioModel?.characteristic.equityCharacteristic.asOfDate | ESTPipe }}
        </p>
    <c11n-tabs activeItem="" smallResponsiveBreakpoint="375" variant="left-aligned" overflowOption="nav-overflow" hasAnimation="true">
      <c11n-tab-panel [attr.data-rpa-tag-id]="'pc-ch-tab-equity'" id="equity" labelText="Equity">
        <div class="c11n-text-crop">
          <equity-characteristic [fundId]='portfolioModel?.profileData?.ticker' [portfolioModel]='portfolioModel' [benchmarkFootNote]='benchmarkFootNote' [portfolioFootNote]='portfolioFootNote'></equity-characteristic>
        </div>
      </c11n-tab-panel>
      <c11n-tab-panel [attr.data-rpa-tag-id]="'pc-ch-tab-fixed-income'" id="fixedIncome" labelText="Fixed income">
        <div class="c11n-text-crop">
          <fixed-income-characteristic [fundId]='portfolioModel?.profileData?.ticker' [portfolioModel]='portfolioModel' [benchmarkFootNote]='benchmarkFootNote' [portfolioFootNote]='portfolioFootNote'></fixed-income-characteristic>
        </div>
      </c11n-tab-panel>
      <c11n-tab-panel [attr.data-rpa-tag-id]="'pc-ch-tab-balanced'" id="balanced" labelText="Balanced">
        <div class="c11n-text-crop">
          <fund-characteristic [fundId]='portfolioModel?.profileData?.ticker' [portfolioModel]='portfolioModel' [benchmarkFootNote]='benchmarkFootNote' [portfolioFootNote]='portfolioFootNote'></fund-characteristic>
        </div>
      </c11n-tab-panel>
    </c11n-tabs>
  </div>
  <div *ngIf="(!portfolioModel?.profileData?.is529 && portfolioModel?.profileData?.isMoneyMarket && !portfolioModel?.profileData?.isStableValueFund &&
              (portfolioModel?.characteristic?.moneyMarketCharacteristic?.fund || portfolioModel?.characteristic?.moneyMarketCharacteristic?.benchmark))">
       <p class="date rps-paragraph-two rps-grey" *ngIf="portfolioModel?.characteristic?.moneyMarketCharacteristic?.asOfDate">as of {{
            portfolioModel?.characteristic.moneyMarketCharacteristic.asOfDate | ESTPipe }}
      </p>
      <div class = "char-table">
      <money-market-characteristic [fundId]='portfolioModel?.profileData?.ticker' [portfolioModel]='portfolioModel'>
      </money-market-characteristic>
    </div>
  </div>
  <div *ngIf="!portfolioModel?.profileData?.is529 && !portfolioModel?.profileData?.isExternalFund && (((portfolioModel?.profileData?.isFundOfFunds && !portfolioModel?.profileData?.isHybridFund) ||
              portfolioModel?.profileData?.isConvertibleFund || portfolioModel?.profileData?.isMarketNeutralFund ||
              portfolioModel?.profileData?.isStableValueFund) && ((portfolioModel?.characteristic?.fundCharacteristic?.fund ||
              portfolioModel?.characteristic?.fundCharacteristic?.benchmark)))">
       <p class="date rps-paragraph-two rps-grey" *ngIf="portfolioModel?.characteristic?.fundCharacteristic?.asOfDate">as of {{
            portfolioModel?.characteristic.fundCharacteristic.asOfDate | ESTPipe }}
       </p>
       <div class = "char-table">
       <fund-characteristic [fundId]='portfolioModel?.profileData?.ticker' [portfolioModel]='portfolioModel'
        [benchmarkFootNote]='benchmarkFootNote' [portfolioFootNote]='portfolioFootNote'>
       </fund-characteristic>
       </div>
   </div>
   <div *ngIf="((portfolioModel?.profileData?.isBond && (!portfolioModel?.profileData?.isConvertibleFund && (portfolioModel?.characteristic?.fixedIncomeCharacteristic?.fund ||
                 portfolioModel?.characteristic?.fixedIncomeCharacteristic?.benchmark))) || portfolioModel?.profileData?.fundId === '0517')">
        <p class="date rps-paragraph-two rps-grey" *ngIf="portfolioModel?.characteristic?.fixedIncomeCharacteristic?.asOfDate">as of {{
            portfolioModel?.characteristic.fixedIncomeCharacteristic.asOfDate | ESTPipe }}
        </p>
        <div class = "char-table">
        <fixed-income-characteristic [fundId]='portfolioModel?.profileData?.ticker' [portfolioModel]='portfolioModel'
         [benchmarkFootNote]='benchmarkFootNote' [portfolioFootNote]='portfolioFootNote'>
        </fixed-income-characteristic>
        </div>
  </div>
  <div *ngIf="!portfolioModel?.characteristic || (!portfolioModel?.characteristic?.equityCharacteristic?.fund && !portfolioModel?.characteristic?.fundCharacteristic?.fund
  && !portfolioModel?.characteristic?.moneyMarketCharacteristic?.fund && !portfolioModel?.characteristic?.fixedIncomeCharacteristic?.fund)" class="no-data">
  <p>This information is temporarily unavailable.</p>
</div>
</div>
